import React from "react"
import { useNavigate } from "react-router-dom"
import { ChevronLeft } from "lucide-react"

const BackButtonNavigation = ({ onClick, className }) => {
    const navigate = useNavigate()
  
    const handleBack = () => {
      if (onClick) {
        onClick()
      } else {
        navigate(-1)
      }
    }
  
    return (
      <ChevronLeft
        onClick={handleBack}
        className={`cursor-pointer text-accumin-neutral-500 ${className}`}
      />
    )
  }

export default BackButtonNavigation